/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import useOutsideClick from '../common/hooks/useOutsideClick';
import { ReactNode, useCallback, useEffect, useMemo, useRef } from 'react';

type TClickAwayListenerProps = {
  onClickAway?: () => void;
  tagName?: keyof JSX.IntrinsicElements;
  children?: ReactNode;
};

const ClickAwayListener = ({ onClickAway, tagName, children }: TClickAwayListenerProps) => {
  const ref = useRef<HTMLElement>(null);
  const callbackRef = useRef<() => void>(() => {});

  useEffect(() => {
    callbackRef.current = onClickAway || (() => {});
  }, [onClickAway]);

  const handleOutsideClick = useCallback(() => {
    if (typeof callbackRef.current !== 'function') return;
    callbackRef.current();
  }, []);

  useOutsideClick(ref, handleOutsideClick);

  const Tag = useMemo(() => tagName || 'span', [tagName]);

  return (
    /* @ts-ignore - Expression produces a union type that is too complex to represent */
    <Tag ref={ref}>{children}</Tag>
  );
};

export default ClickAwayListener;
